import { useCallback, useEffect, useState } from 'react';
import useGenericEventProcessor from '@hooks/processors/use-generic-event-processor';
import apiClient from '@utils/api-client';
import { apiInternalGenericEventPath } from '../../routes';
const useGetGenericEvent = (id) => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const { processGenericEvent } = useGenericEventProcessor();
    const fetchData = useCallback((fetchId, controller) => {
        setLoading(true);
        apiClient
            .get(apiInternalGenericEventPath(fetchId), {
            signal: controller.signal
        })
            .then((response) => {
            setData(processGenericEvent(response.data.data));
        })
            .catch((err) => {
            if (!controller.signal.aborted) {
                setData(undefined);
                setError(err);
            }
        })
            .finally(() => {
            if (!controller.signal.aborted) {
                setLoading(false);
            }
        });
    }, []);
    const refetchData = useCallback(() => {
        const controller = new AbortController();
        fetchData(id, controller);
        return () => {
            controller.abort();
        };
    }, [id]);
    useEffect(() => {
        const controller = new AbortController();
        fetchData(id, controller);
        return () => {
            controller.abort();
        };
    }, [id]);
    return { data, loading, error, refetchData };
};
export default useGetGenericEvent;
